import { RequestECatalogItem } from "./request-e-catalog-response";

interface ECatalogTableItem extends RequestECatalogItem {
    inputName: string;
}

const row = ({
    number,
    name,
    eCatalogAvailable,
    location,
    isFav,
    toggleFavUrl,
    inputName,
}: ECatalogTableItem): string => {
    return `
        <tr>
            <td>${
                eCatalogAvailable
                    ? `<ux-checkbox name="${inputName}" no-label value="${number}" />`
                    : `<ux-checkbox name="${inputName}" no-label disabled />`
            }</td>
            <td>
                <ux-iws-async-toggle-button sync-id="${number}" ${isFav ? "on" : "off"} toggle-url="${toggleFavUrl}">
                    <ux-icon slot="on" name="bookmark" filled=""></ux-icon>
                    <ux-icon slot="off" name="bookmark"></ux-icon>
                </ux-iws-async-toggle-button>
            </td>
            <td>${name}</td>
            <td>${number}</td>
            <td>${location}</td>
        </tr>
    `;
};

export default row;
